import React from 'react'
import { button } from '@/styles/theme/components/button'
import type { ButtonProps } from './types'

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
    ({
        className = '',
        variant = 'default',
        size = 'default',
        children,
        ...props
    }, ref) => {
        return (
            <button
                ref={ref}
                data-circle="button"
                className={`
                    ${button.base}
                    ${button.variants[variant]}
                    ${button.sizes[size]}
                    ${className}
                `}
                {...props}
            >
                {children}
            </button>
        )
    }
)

Button.displayName = 'Button'

export default Button